// extracted by mini-css-extract-plugin
export var calcWithForm = "Tooltip-module--calcWithForm--pelpI";
export var close = "Tooltip-module--close--opKPY";
export var contentTooltip = "Tooltip-module--contentTooltip--wDYme";
export var hintText = "Tooltip-module--hintText--BHZmt";
export var installmentPlanPopup = "Tooltip-module--installmentPlanPopup--ZM0QV";
export var installmentPlanTooltip = "Tooltip-module--installmentPlanTooltip--vyNeI";
export var tooltipIcon = "Tooltip-module--tooltipIcon--a5w9L";